
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import placesServices from '../../services/placesServices';
import favoritesLogo from '../../assets/images/love.svg';
import fillFavoritesLogo from '../../assets/images/love-fill.svg';
// import locationLogo from '../../assets/images/location.png';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import { useAuth } from '../../Context/AuthContext';
// import { ReactPhotoCollage } from "react-photo-collage";
import '../../scss/style/place_details.scss';
import Reviews from '../../components/reviews/Reviews';
import addLoc from '../../assets/images/add-loc.png'
import view360 from '../../assets/images/360view.png'
import ReactStars from 'react-rating-stars-component';
import Gallery from '../../components/gallery/gallery';
import Loading from '../../components/loading/Loading';

export default function PlaceDetails() {

    const addReviewRef = useRef(null);  // Create a ref

    const handleAddReviewClick = () => {
        // Function to scroll to the "Add Review" section
        if (addReviewRef.current) {
            addReviewRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleLocationButtonClick = () => {
        if (url) {
            //   window.location.href = url; // Redirect to the fetched URL
            window.open(url, '_blank'); // Open the URL in a new tab
        } else {
            alert('URL not available');
        }
    };


    // const images = [
    //     'https://media.newyorker.com/photos/64bc4330ef09d4a0e04cb249/1:1/w_1707,h_1707,c_limit/Rosen-Messi-Miami.jpg',
    //     'https://assets.goal.com/v3/assets/bltcc7a7ffd2fbf71f5/bltcad7bd066b858c46/633ef9dca846b03282ff2b95/Social-16-9_(2).jpg?auto=webp&format=pjpg&width=3840&quality=60',
    //     'https://upload.wikimedia.org/wikipedia/commons/b/b4/Lionel-Messi-Argentina-2022-FIFA-World-Cup_%28cropped%29.jpg',
    //     'https://media.newyorker.com/photos/64bc4330ef09d4a0e04cb249/1:1/w_1707,h_1707,c_limit/Rosen-Messi-Miami.jpg',
    //     'https://assets.goal.com/v3/assets/bltcc7a7ffd2fbf71f5/bltcad7bd066b858c46/633ef9dca846b03282ff2b95/Social-16-9_(2).jpg?auto=webp&format=pjpg&width=3840&quality=60',
    //     'https://upload.wikimedia.org/wikipedia/commons/b/b4/Lionel-Messi-Argentina-2022-FIFA-World-Cup_%28cropped%29.jpg'
    //     // Add more image URLs as needed
    // ];

    // const handleRatingChange = (newRating) => {
    //     console.log(Rated ${newRating} stars!);
    // };

    const [activeTab, setActiveTab] = useState('facts');
    const { placeID } = useParams();
    const [place, setPlace] = useState(null);
    const [url, setUrl] = useState('');
    console.log(place);
    const [favoritesMap, setFavoritesMap] = useState({});
    const { getFavourite, addFavourite, deleteFavourite, getAverageRate } = useAuth();
    const [averageRating, setAverageRating] = useState(0);

    const images = place ? place.images.map((image, index) => ({ source: image, id: index })) : [];
    // console.log(images);

    // const setting = {
    //     width: '1083px',
    //     height: ['450px', '170px'],
    //     layout: [1, 4],
    //     photos: place ? place.images.map((image, index) => ({ source: image, id: index })) : [],
    //     showNumOfRemainingPhotos: true
    // };

    const [loading, setLoading] = useState(false); // Added loading state
    const navigate = useNavigate();

    const navigateTo3DModels = () => {
        navigate('/3D-Models');
    };

    useEffect(() => {
        setLoading(true);
        placesServices.getOne(placeID).then((place) => {
            setPlace(place);
            setUrl(place.google_maps_link);
            setTimeout(() => {
                setLoading(false);
            }, 1000); // Hide loading after 1 second
        }).catch((error) => {
            console.error('Error fetching places:', error);
            // Set loading to false in case of error
            setLoading(false);
        });
    }, [placeID]);

    useEffect(() => {
        const fetchAverageRating = async () => {
            try {
                const response = await getAverageRate(placeID);
                console.log("API Response:", response);
                const avgRate = parseFloat(response.data.data.average_rating);
                console.log("mmmmmmm" + avgRate);
                setAverageRating(avgRate);
            } catch (error) {
                console.error('Error fetching average rating:', error);
            }
        };

        fetchAverageRating();
    }, [placeID]);



    useEffect(() => {
        async function fetchFavorites() {
            try {
                const userFavorites = await getFavourite();
                if (userFavorites && Array.isArray(userFavorites)) {
                    const favoritesHashMap = {};
                    userFavorites.forEach((fav) => {
                        favoritesHashMap[fav.id] = true;
                    });
                    setFavoritesMap(favoritesHashMap);
                    localStorage.setItem('favorites', JSON.stringify(favoritesHashMap));
                } else {

                    console.error('User favorites not found or not in the expected format.');
                }
            } catch (error) {

                console.error('Error fetching user favorites:', error);
            }
        }

        fetchFavorites();
    }, [getFavourite]);


    useEffect(() => {
        const storedFavorites = localStorage.getItem('favorites');
        if (storedFavorites) {
            const parsedFavorites = JSON.parse(storedFavorites);
            setFavoritesMap(parsedFavorites);
        }
    }, []);


    const isFavorite = favoritesMap[placeID] || false; // Ensure isFavorite is boolean

    const handleFavoriteToggle = async () => {
        if (isFavorite) {
            deleteFavourite(placeID);
            const updatedMap = { ...favoritesMap };
            delete updatedMap[placeID];
            setFavoritesMap(updatedMap);
            localStorage.setItem('favorites', JSON.stringify(updatedMap)); // Update localStorage
        } else {
            addFavourite({ site_id: placeID });
            setFavoritesMap({ ...favoritesMap, [placeID]: true });
            localStorage.setItem('favorites', JSON.stringify({ ...favoritesMap, [placeID]: true })); // Update localStorage
        }
    };

    if (!place) {
        return (
            <div>
                <NavBar />
                {loading && <div className='overlay'> <Loading /> </div>} {/* Show loading component when loading is true */}
            </div>
        )
    }
    return (
        <div>
            <NavBar />
            <div className="new-outer-single-container">
                {loading && <div className='overlay'> <Loading /> </div>}
                <div className='new-inner-single-container'>
                    <div className='name-rate-fav-container'>
                        <div className='name-and-stars-div'>
                            <div className='place-name'>{place.name}</div>
                            {averageRating > 0 && ( // Conditionally render ReactStars
                                <ReactStars
                                    count={5}
                                    value={averageRating}
                                    size={24}
                                    activeColor="#ffd700"
                                    edit={false}
                                />
                            )}
                        </div>
                        <div><img
                            className="fav-logo"
                            src={isFavorite ? fillFavoritesLogo : favoritesLogo}
                            alt="favorites-logo"
                            onClick={handleFavoriteToggle}
                        /></div>
                    </div>
                    <Gallery images={images} />
                </div>
                <div className='three-buttons'>
                    <button className="add-rev" onClick={handleAddReviewClick}>Add Review</button>
                    <button className="open-loc" onClick={handleLocationButtonClick}>
                        <img className='loc-view-logo' src={addLoc} alt="loc logo" />
                        Open Location
                    </button>
                    <button onClick={navigateTo3DModels} className="view360">
                        <img className='loc-view-logo' src={view360} alt="360 view logo" />
                        3D Model
                    </button>
                </div>

                <div className='facts-events-container'>
                    <div className='facts-events-box'>
                        <div
                            className={`facts-events-text ${activeTab === 'facts' ? 'active' : ''}`}
                            onClick={() => setActiveTab('facts')}
                        >FACTS</div>
                        <div
                            className={`facts-events-text ${activeTab === 'historical' ? 'active' : ''}`}
                            onClick={() => setActiveTab('historical')}
                        >HISTORICAL EVENTS</div>
                    </div>
                    {activeTab === 'facts' && <div className='place-facts'>{place.description}</div>}
                    {activeTab === 'historical' && <div className='place-facts scrollable'>{place.events.map((item, index) => (<div key={index}>
                        <div className='event-year'>{item.year}</div>
                        <div className='event-description'>{item.event}</div>
                    </div>))}</div>}
                </div>
            </div>








            {/* <div className="outer-single-container">
                <div className="inner-single-container">
                    <img className="single-image" src={place.images[0]} alt={place.city} />
                    <img
                        className="favorites-logo"
                        src={isFavorite ? fillFavoritesLogo : favoritesLogo}
                        alt="favorites-logo"
                        onClick={handleFavoriteToggle}
                    />
                    <img className="location-logo" src={locationLogo} alt='location-logo' />
                    <div className="texts-single-container">
                        <div className="single-name">{place.name}</div>
                        <div className="single-description">{place.description}</div>
                    </div>
                    <button className="review-button">Add Review</button>
                </div>
            </div>

            <div className='gallery-outer-container'>
                <div className='gallery-inner-container'>
                    <h2 className='other-photos-text'>Other Photos</h2>
                    <ReactPhotoCollage {...setting} />
                </div>
            </div> */}
            <Reviews ref={addReviewRef} placeID={placeID} />


            <Footer />
        </div>
    )
}